export const HAS_PENDING_COPY_INFO_TEXT =
  'This quiz is already in your Shared with Me list with a “Not yet accepted” status. The action you take here will update this quiz.”';
export const HAS_COPY_INFO_TEXT =
  'You have already made a copy of this shared quiz. The actions taken below would add a new quiz to your “Shared with Me” list.';
